export default "<p>rewards-digital works!</p>\n"